import type { SessionUser } from "@ziolo/shared";
import { Button } from "./Button.js";

export interface UserBarProps {
  user: SessionUser;
  onLogout?: (() => void) | undefined;
  adminHref?: string | undefined;
}

/** Session strip under the navbar. Keeps logout out of the Menu cluster. */
export function UserBar({ user, onLogout, adminHref }: UserBarProps) {
  return (
    <div className="z-userbar">
      <span className="z-userbar__who">
        <span className="z-userbar__who-label">Zalogowano jako </span>
        <strong>{user.username}</strong>
      </span>
      <div className="z-userbar__actions">
        <div id="z-userbar-extra" className="z-userbar__extra" />
        {adminHref ? (
          <a className="z-btn z-btn--sm" href={adminHref}>
            Admin
          </a>
        ) : null}
        <Button size="sm" onClick={onLogout}>
          Wyloguj
        </Button>
      </div>
    </div>
  );
}
